import { Helmet } from "react-helmet-async";
import { useSite } from "@/context/SiteContext";

export function SEO({ page, title, description, path = "/", image, jsonLd, type = "website", noindex = false }) {
  const site = useSite();
  const pageSeo = (site.page_seo && site.page_seo[page]) || {};
  const finalTitle = title || pageSeo.title || "Ravi Works | SEO Specialist";
  const finalDesc = description || pageSeo.description || site.tagline;
  const canonical = `${site.domain}${path === "/" ? "/" : path}`;
  const ogImage = image || `${site.domain}/favicon.svg`;

  return (
    <Helmet>
      <title>{finalTitle}</title>
      <meta name="description" content={finalDesc} />
      <link rel="canonical" href={canonical} />
      <meta name="robots" content={noindex ? "noindex,nofollow" : "index,follow"} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={site.brand} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDesc} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDesc} />
      <meta name="twitter:image" content={ogImage} />
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}

export function orgJsonLd(site) {
  return {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    name: site.brand,
    url: site.domain,
    email: site.email,
    telephone: site.phone_display,
    description: "SEO specialist consultancy: technical SEO, on-page SEO, content SEO, local SEO, e-commerce SEO, link building and SEO audits.",
  };
}

export function websiteJsonLd(site) {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: site.brand,
    url: site.domain,
  };
}

export function breadcrumbJsonLd(site, items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: `${site.domain}${it.path}`,
    })),
  };
}
